import React from 'react';
import PropTypes from 'prop-types';

import { MDText } from 'i18n-react';

import { ComponentContent, CONTENT_SIZES } from 'Layout';

import TrustPilotImage from '../../../fastlane/TrustPilotImage/TrustPilotImage';
import LocalTexts from '../AffiliatePageTexts.json';

import VRM from './VRM';

import styles from './Hero.scss';

const LocalT = new MDText(LocalTexts);

const Hero = ({ affiliate = '' }) => (
  <div className={styles.heroWrapper}>
    <ComponentContent className={styles.heroContent} maxWidth={CONTENT_SIZES.container} selector="section">
      {/* <h1 className={styles.heroTitle}>
        {LocalT.translate('mainTitle')}
      </h1> */}
      <h1 className={styles.heroTitle}>
        The way to
        {' '}
        <div className={styles.second}>
          <span>sell your car</span>
        </div>
      </h1>
      <p className={styles.description}>
        {LocalT.translate('heroStrap')}
      </p>
      <TrustPilotImage className={styles.trustPilot} />
      <VRM affiliate={affiliate} />
    </ComponentContent>
  </div>
);

Hero.propTypes = {
  affiliate: PropTypes.string,
};

export default Hero;
